<template>
  <div class="area-switch">
    <div class="area-switch-shadow" @click="hidePopup"></div>
    <div class="area-switch-main">
      <p class="main-title">{{ letter.areaLimitSwitchRegion }}</p>
      <div class="main-content">
        <div class="main-form-box">
          <div class="main-form-box-item">
            <p>{{ letter.selectCountry }}</p>
            <div class="main-select" @click="showAreaSelect">
              <span>{{ nextLocationName || curLocationName }}</span>
              <em class="lang-switch-ico-sanjiao"></em>
            </div>
          </div>
          <div class="main-form-box-item">
            <p>{{ letter.areaLimitCurrency }}</p>
            <Select class="main-select" v-model="nextCurrency">
              <template slot="option">
                <option
                  v-for="item in locationCurrencyList"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </template>
              <template slot="ico">
                <em class="lang-switch-ico-sanjiao"></em>
              </template>
            </Select>
          </div>
        </div>
        <template v-if="nextLocationVal === 'US'">
          <div class="main-form-box">
            <div class="main-form-box-item">
              <p>{{ letter.zipCodeState }}</p>
              <DataList
                class="main-select main-input"
                v-bind:value.sync="nextStateName"
                :options="usStateOptions"
                @select="selectState"
              ></DataList>
            </div>
            <div class="main-form-box-item">
              <p>zipcode</p>
              <DataList
                class="main-select main-input"
                v-bind:value.sync="nextZipCode"
                :options="zipCodeOptions"
                @change="zipcodeChange"
                type="number"
              ></DataList>
            </div>
          </div>
          <p v-if="nextLocationVal === 'US'" class="main-tax-tips">
            {{ `${letter.zipCodeRate}:${curTaxRate}%` }}
          </p>
          <p v-if="!zipCodeValidor" class="main-tips">
            {{ letter.areaLimitEnterInvalid }}
          </p>
        </template>
        <p
          v-html="
            letter.areaLimitRemainingSwitches.replace(
              '\${times}',
              `<span class='main-tips'>${modifyCount}</span>`
            )
          "
        ></p>
        <template v-if="nextLocationVal === 'US'">
          <p>{{ letter.areaLimitTaxRateTips }}</p>
          <!-- 还没有多语言，暂时写死英语，后续可替换为已有的对应多语言 -->
          <p
            @click="jumpAreaLimitPolicy"
            v-html="
              letter.areaLimitInfoCollect.replace(
                '\${policy}',
                `<span class='area-switch-popup-link'>[Privacy Policy]</span>`
              )
            "
          ></p>
        </template>
        <div class="main-btn-wrap">
          <a
            class="confirm btn"
            href="javascript:;"
            @click="submitAreaSwithInfo('V1')"
          >
            {{ letter.areaLimitConfirmSwitch }}
          </a>
        </div>
        <a href="javascript:;" class="main-close" @click="hidePopup"></a>
      </div>
    </div>
    <transition name="fade">
      <AreaSelecter
        v-if="showAreaSelector"
        v-on:closeSelecter="showAreaSelector = false"
        v-on:hideAreaSelector="hideAreaSelector"
        :curLocationsVal="nextLocationVal"
        v-bind:showChildSelector="showAreaSelector"
        :locations="locations"
      ></AreaSelecter>
    </transition>
  </div>
</template>

<script>
import AreaSelecter from '@components/officialStore/paytype/AreaSelecter';
import areaLimit from '@mixins/areaLimit';
import zipcode from '@mixins/officialStore/zipcode';
import { mapState } from 'vuex';
import { GET_LOCATION_CURRENCY_LIST } from '@store/officialStore';
import DataList from '../common/DataList.vue';
export default {
  name: 'AreaSwitchPopup',
  props: ['zipCode'],
  mixins: [areaLimit, zipcode],
  data() {
    return {
      nextZipCode: '',
      isEditZipCode: false
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      locationModifyCount: state => state.locationModifyCount,
      maxLocationModifyCount: state => state.maxLocationModifyCount,
      defaultCurrency: state => state.defaultCurrency
    }),
    modifyCount() {
      return this.maxLocationModifyCount
        ? this.maxLocationModifyCount - this.locationModifyCount
        : 0;
    },
    zipCodeOptions() {
      return this.currentZipCodeList.filter(item =>
        item.value.includes(this.nextZipCode)
      );
    },
    usStateOptions() {
      const US_STATES = this.getUsStateOptions();
      return US_STATES.filter(item => {
        return item.label
          .toUpperCase()
          .includes(this.nextStateName.toUpperCase());
      });
    }
  },
  methods: {
    getLocationCurrencyList(locationCode, isInit = false) {
      this.$store
        .dispatch(GET_LOCATION_CURRENCY_LIST, { location_code: locationCode })
        .then(res => {
          this.locationCurrencyList = res.data;
          if (!isInit) {
            this.nextCurrency = this.locationCurrencyList?.[0];
          }
        });
    },
    // 选择美国州
    selectState(curState) {
      this.nextZipCode = '';
      this.nextStateName = curState.label;
      this.nextStateCode = curState.value;
      this.getZipCodeList(curState.value);
    },
    async zipcodeChange() {
      await this.zipCodeValidorFunc();
    }
  },
  watch: {
    nextLocationVal(val) {
      this.getLocationCurrencyList(val, false);
    },
    nextZipCode(val) {
      if (val && val !== this.ipZipCode) {
        this.isEditZipCode = true;
      }
    }
  },
  created() {
    this.getLocationCurrencyList(this.nextLocationVal, true);
    this.nextCurrency = this.defaultCurrency;
    this.nextZipCode = this.zipCode || this.ipZipCode || '';
    this.zipCodeValidorFunc();
  },
  components: {
    AreaSelecter
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';
.area-switch {
  z-index: 21;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    @psetbg ('area-limit-bg.png', true, false);
    background-size: 100% 100%;
  }
}
.main {
  &-close {
    position: absolute;
    right: 32px;
    top: 27px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    @psetbg ('close.png');
  }
  &-title {
    margin-top: 70px;
    background-image: -webkit-linear-gradient(
      top,
      var(--area-limit-title-color-top),
      var(--area-limit-title-color-bottom)
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  &-content {
    font-size: 24px;
    text-align: start;
    padding: 60px 50px;
    line-height: 1.5;
    margin-bottom: 160px;
    color: var(--area-limit-main-text-color);
  }
  &-content-title {
    font-size: 28px;
    line-height: 36px;
    font-weight: bold;
    color: var(--area-limit-main-title-color);
    margin-bottom: 36px;
  }
  &-select {
    box-sizing: border-box;
    position: relative;
    margin: 10px 10px 10px 0;
    padding: 0 20px;
    height: 80px;
    border-radius: 6px;
    color: var(--area-limit-main-title-color);
    background-color: var(--area-limit-now-box-bg-color) !important;
    border: solid 2px;
    border-color: var(--area-limit-now-box-border-color) !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 22px;
    cursor: pointer;
    ::v-deep .select {
      color: var(--area-limit-main-title-color) !important;
      padding: 0 20px !important;
    }
    ::v-deep .select-icon {
      right: 0;
    }
  }
  &-btn-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 65px;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      font-size: 28px;
      color: #fff;
      cursor: pointer;
    }
    .confirm {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('area-limit-btn.png');
    }
  }
  &-form-box {
    display: flex;

    &-item {
      width: 50%;
      box-sizing: border-box;
      color: var(--area-limit-main-title-color);
    }
    &-item + &-item {
      margin-left: 10px;
    }
  }
  &-tax-tips {
    float: right;
    width: 50%;
  }
}
.lang-switch {
  &-ico-sanjiao {
    display: inline-block;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 50%;
    right: 25px;
    transform: translateY(-50%);
    @psetbg ('area-limit-arrow.png');
  }
}

::v-deep .datalist-input {
  font-size: 22px;
  color: var(--area-limit-main-title-color);
}
::v-deep .datalist-options {
  background-color: var(--area-limit-now-box-bg-color) !important;
}
</style>
<style lang="scss">
.main-tips {
  color: var(--area-limit-main-tips-color);
}
.area-switch-popup-link {
  color: var(--area-limit-main-tips-color);
  cursor: pointer;
  text-decoration: underline;
}
</style>
